import './App.scss';
import { Routes,Route } from 'react-router-dom';
import Router from './pages/router/router';

function App() {
  return (
    <div className="App">
      <Router/>
  
    </div>
  );
}

export default App;
